import { render } from "./StudyMaterialAdmin.vue?vue&type=template&id=b6ddc8fa&scoped=true"
import script from "./StudyMaterialAdmin.vue?vue&type=script&lang=js"
export * from "./StudyMaterialAdmin.vue?vue&type=script&lang=js"

import "./StudyMaterialAdmin.vue?vue&type=style&index=0&id=b6ddc8fa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ddc8fa"]])

export default __exports__